export interface BlogArticle {
  id: number;
  title: string;
  excerpt: string;
  content: string;
  imageUrl?: string;
}

export const blogArticles: BlogArticle[] = [
  {
    id: 1,
    title: "Typy aukcí a proč je holandská aukce tak výhodná",
    excerpt:
      "Co je to aukce? Aukce je způsob prodeje, při kterém se cena zboží nebo služby určuje na základě poptávky – a tedy ochoty kupujících přihazovat. Na trhu existuje několik typů aukcí a každá má svá specifika. Pojďme se na ně podívat a zjistit, proč právě holandská aukce nabízí jedinečnou dynamiku.",
    content: `Co je to aukce? Aukce je způsob prodeje, při kterém se cena zboží nebo služby určuje na základě poptávky – a tedy ochoty kupujících přihazovat. Na trhu existuje několik typů aukcí a každá má svá specifika. Pojďme se na ně podívat a zjistit, proč právě holandská aukce nabízí jedinečnou dynamiku.

Tradiční anglická aukce
Nejznámější typ aukce, při které cena začíná nízko a účastníci přihazují. Vyhrává ten, kdo nabídne nejvyšší cenu. Tento typ je skvělý pro vzácné předměty a sběratele.

Holandská aukce
Na rozdíl od anglické aukce zde cena klesá. Začíná se na vysoké ceně a ta postupně padá, dokud někdo neklikne a nekoupí. Výhoda? Můžete získat zboží za výrazně nižší cenu než je běžná tržní hodnota.

Proč je holandská aukce tak výhodná?
1. Transparentnost - vidíte, jak cena klesá v reálném čase
2. Férová soutěž - každý má stejnou šanci
3. Úspora peněz - můžete ušetřit až desítky procent
4. Vzrušení - sledování klesající ceny je opravdu napínavé

Vyzkoušejte naši platformu a přesvědčte se sami!`,
    imageUrl:
      "https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=250&h=250&fit=crop",
  },
  {
    id: 2,
    title: "Jak hrát holandskou aukci?",
    excerpt:
      "Rychlý úvod: co je holandská aukce? Holandská aukce je forma prodeje, kdy cena začíná na běžné tržní ceně a postupně klesá. Účastníci sledují vývoj a snaží se v pravý moment kliknout a \"trefit\" nejlepší cenu – dřív než ostatní.",
    content: `Rychlý úvod: co je holandská aukce? Holandská aukce je forma prodeje, kdy cena začíná na běžné tržní ceně a postupně klesá. Účastníci sledují vývoj a snaží se v pravý moment kliknout a "trefit" nejlepší cenu – dřív než ostatní.

Jak na to krok za krokem:

1. Zaregistrujte se
Vytvořte si účet na naší platformě. Je to zdarma a zabere to jen minutu.

2. Vyberte si aukci
Prohlédněte si nabídku produktů a vyberte ten, který vás zajímá.

3. Sledujte klesající cenu
Cena začíná na běžné tržní hodnotě a postupně klesá. Sledujte ji pozorně!

4. Klikněte ve správný moment
Když je cena pro vás výhodná, klikněte na tlačítko "KOUPIT HNED". Kdo klikne první, vyhrává.

5. Dokončete nákup
Zboží je vaše! Dokončete platbu a těšte se na dodání.

Tipy pro úspěch:
- Stanovte si maximální cenu, kterou jste ochotni zaplatit
- Sledujte aukce předem, abyste měli přehled o tempu klesání
- Buďte připraveni kliknout rychle – ostatní čekají na stejnou příležitost
- Nenechte se unést – aukce má být zábava, ne stres`,
    imageUrl:
      "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=250&h=250&fit=crop",
  },
  {
    id: 3,
    title: "Historie a slavné příklady holandské aukce",
    excerpt:
      "Kde to všechno začalo? Holandská aukce má svůj původ – jak název napovídá – v Nizozemsku. Už v 17. století ji používali pěstitelé tulipánů k prodeji květin. Kvůli velkému množství zboží potřebovali rychlý a efektivní způsob prodeje – a tak vznikl systém s klesající cenou.",
    content: `Kde to všechno začalo? Holandská aukce má svůj původ – jak název napovídá – v Nizozemsku. Už v 17. století ji používali pěstitelé tulipánů k prodeji květin. Kvůli velkému množství zboží potřebovali rychlý a efektivní způsob prodeje – a tak vznikl systém s klesající cenou.

Tulipánová mánie (1634-1637)
V období tulipánové mánie se holandská aukce stala klíčovým nástrojem obchodu s cibulkami tulipánů. Ceny některých odrůd dosahovaly astronomických výšin a aukce pomáhaly rychle určit tržní hodnotu.

Moderní využití
Dnes se holandská aukce používá v mnoha odvětvích:

Burzy květin
Největší květinová burza na světě – FloraHolland – stále používá systém holandské aukce. Každý den se zde prodají miliony květin.

IPO akcií
Některé společnosti, včetně Google, použily holandskou aukci pro svou první veřejnou nabídku akcií.

Online platformy
Moderní e-commerce platformy přinesly holandskou aukci do digitálního věku. Umožňují zákazníkům sledovat klesající ceny v reálném čase a nakupovat za výhodné ceny.

Státní dluhopisy
Mnoho zemí, včetně USA, používá holandskou aukci pro prodej státních dluhopisů.

Holandská aukce přežila staletí, protože je férová, transparentní a výhodná pro všechny zúčastněné.`,
    imageUrl:
      "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=250&h=250&fit=crop",
  },
];
